module.exports = __webpack_public_path__ + "static/media/profile-icon.11cedc44.png";